import { useCallback, useState, FC } from 'react';

import Button from '../../../buttons/Button';
import SubscriptionHistoryItem, {
  SubscriptionHistoryItemProps
} from '../SubscriptionHistoryItem';

import { ListContainer, ShowAllButton } from './Wrapper';

const VISIBLE_ITEM_COUNT = 5;

export type SubscriptionHistoryListProps = {
  list: SubscriptionHistoryItemProps[];
};

const SubscriptionHistoryList: FC<SubscriptionHistoryListProps> = ({
  list
}) => {
  const [isExpanded, setExpanded] = useState(false);
  const expand = useCallback(() => setExpanded(true), []);

  return (
    <>
      <ListContainer>
        {list.map(
          (itemProps, i) =>
            (isExpanded || i < VISIBLE_ITEM_COUNT) && (
              <SubscriptionHistoryItem key={itemProps.id} {...itemProps} />
            )
        )}
      </ListContainer>

      {!isExpanded && list.length > VISIBLE_ITEM_COUNT && (
        <ShowAllButton>
          <Button size="big" variant="blue-heavy-border" onClick={expand}>
            Show More
          </Button>
        </ShowAllButton>
      )}
    </>
  );
};

export default SubscriptionHistoryList;
